import { 
  Car, 
  UserCircle, 
  Wrench, 
  Building, 
  DollarSign, 
  Cog, 
  TrendingUp, 
  FileText,
  CircleDashed,
  Fuel,
  Radio,
  Gauge,
  Timer,
  Trophy,
  MapPin,
  LayoutDashboard,
  RefreshCw,
  ClipboardList,
  type LucideIcon
} from "lucide-react";
import { VehicleReports } from "../VehicleReports";
import { DriverReports } from "../DriverReports";
import { MaintenanceReports } from "../MaintenanceReports";
import { CostCenterReports } from "../CostCenterReports";
import { FinancialReports } from "../FinancialReports";
import { OperationalReports } from "../OperationalReports";
import ComparativeReports from "../ComparativeReports";
import { DocumentReports } from "../DocumentReports";
import { TireReports } from "../TireReports";
import { FuelReports } from "../FuelReports";
import VehicleMaintenanceSummaryReport from "../VehicleMaintenanceSummaryReport";
import { GpsDistanceReport } from "../gps/GpsDistanceReport";
import { GpsSpeedViolationsReport } from "../gps/GpsSpeedViolationsReport";
import { GpsIdleTimeReport } from "../gps/GpsIdleTimeReport";
import { GpsDriverScoreReport } from "../gps/GpsDriverScoreReport";
import { GpsJourneyReport } from "../gps/GpsJourneyReport";
import ConsolidatedReport from "../ConsolidatedReport";
import FleetRenewalAnalysis from "../FleetRenewalAnalysis";
import DetailedMaintenanceReport from "../DetailedMaintenanceReport";

export interface ReportConfig {
  id: string;
  label: string;
  icon: LucideIcon;
  component: React.ComponentType<any>;
  filters: string[];
  description?: string;
}

export const REPORT_CONFIGS: ReportConfig[] = [
  {
    id: 'consolidated',
    label: 'Consolidado',
    icon: LayoutDashboard,
    component: ConsolidatedReport,
    filters: ['period', 'vehicle', 'driver'],
    description: 'Visão unificada de toda a frota com filtros dinâmicos'
  },
  {
    id: 'vehicles',
    label: 'Veículos',
    icon: Car,
    component: VehicleReports,
    filters: ['period', 'vehicle'],
    description: 'Detalhamento completo por veículo'
  },
  {
    id: 'maintenance',
    label: 'Manutenção',
    icon: Wrench,
    component: MaintenanceReports,
    filters: ['period', 'vehicle'],
    description: 'Planos de manutenção e ordens de serviço'
  },
  {
    id: 'maintenance-detailed',
    label: 'Manutenção Detalhado',
    icon: ClipboardList,
    component: DetailedMaintenanceReport,
    filters: ['period', 'vehicle'],
    description: 'Relatório detalhado com itens por fornecedor'
  },
  {
    id: 'fuel',
    label: 'Abastecimentos',
    icon: Fuel,
    component: FuelReports,
    filters: ['period', 'vehicle'],
    description: 'Histórico de abastecimentos por veículo'
  },
  {
    id: 'cost-centers',
    label: 'Centro de Custo',
    icon: Building,
    component: CostCenterReports,
    filters: ['period', 'costCenter'],
    description: 'Relatório consolidado por centro de custo'
  }
];

export const getReportConfig = (reportId: string): ReportConfig | undefined => {
  return REPORT_CONFIGS.find(config => config.id === reportId);
};
